import { AppLayoutBreakpoint } from '../../../util/responsiveness';

import { useAppLayoutWidth } from './useAppLayoutContext';

/**
 * Returns whether the leftnav is suppressed based on the current app layout width.
 */
export const useIsLeftNavSuppressedAtCurrentWidth = (): boolean => useAppLayoutWidth() < AppLayoutBreakpoint.Width812;
